<template>
  <div class="page-header">
    <header-top-nav></header-top-nav>
    <header-search @SearchChange="SearchChange" />
    <div class="shadow"></div>
  </div>
</template>
<script>
import HeaderTopNav from '@/components/header/HeaderTopNav'
import HeaderSearch from '@/components/header/HeaderSearch'
export default {
  name: 'PageHeader',
  components: {
    HeaderTopNav,
    HeaderSearch
  },
  methods: {
    SearchChange (key) {
      this.$emit('SearchChange', key)
    }
  }
}
</script>
<style lang="less" scoped>
.page-header {
  background: #fff;
  .shadow {
    background: #f6f6f6;
    height: 40px;
    -webkit-box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.07) inset;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.07) inset;
  }
}
</style>